import * as s from "react";
import { L as i, l as n } from "./index.js";
const v = (l, c) => {
  const o = s.useContext(i), a = s.useMemo(() => {
    var e;
    const t = c || n[l], u = (e = o == null ? void 0 : o[l]) !== null && e !== void 0 ? e : {};
    return Object.assign(Object.assign({}, typeof t == "function" ? t() : t), u || {});
  }, [l, c, o]), r = s.useMemo(() => {
    const e = o == null ? void 0 : o.locale;
    return o != null && o.exist && !e ? n.locale : e;
  }, [o]);
  return [a, r];
};
export {
  v as u
};
